export default {

        /**
         * Process events
         */
        TRIP_CREATED: 'trip-created',
        TRIP_START_BOOK: 'trip-book-start',
        TRIP_START_HOLD: 'trip-hold-start',
        TRIP_FINISH_BOOK: 'trip-book-finish',
        TRIP_FINISH_HOLD: 'trip-hold-finish',
        TRIP_CANCEL_CHECKOUT_PROCESS: 'trip-cancel-checkout-process',
        TRIP_REFRESH: 'trip-checkout-type',
        TRIP_UPDATE_COSTS: 'trip-update-costs',
        TRIP_DETAILS_UPDATE: 'trip-detail-update',
        TRIP_DETAILS_UPDATE_FOR_SEATS: 'trip-detail-update-for-seats',
        TRIP_DETAILS_UPDATE_FOR_SEATS_FINISHED: 'trip-detail-update-for-seats-finished',
        TRIP_HIDE_PAYMENT_CODES: 'trip-hide-payment-codes',
        TRIP_SHOW_PAYMENT_CODES: 'trip-show-payment-codes',
        TRIP_CANCEL_ITEM: 'trip-cancel-item',
        TRIP_SHOW_CHANGES_BLOCK: 'trip-show-changes-block',
        TRIP_ADULT_SAVED: 'trip-adult-saved',
        TRIP_INFANT_SAVED: 'trip-infant-saved',
        TRIP_CHECKOUT_SUBMIT_TRY: 'trip-checkout-submit-try',
        TRIP_CHECKOUT_BUTTON_START: 'trip-checkout-button-start',
        TRIP_CHECK_AVAILABILITY: 'trip-check-availability',
        TRIP_REFRESH_ITINERARY: 'trip-refresh-itinerary',
        TRIP_SUBMIT_APPROVAL_FORM: 'trip-submit-approval-form',
        TRIP_REFRESH_CHECKOUT_FORM_STATE: 'trip-refresh-checkout-form-state',
        LUGGAGE_CHANGED: 'luggage-changed',
        UPDATE_CREDIT_CARDS: 'update-credit-cards',
        UPDATE_DISCOUNT_LUGGAGE: 'update-discount-luggage',
        CLEAR_APPROVER: 'clear-approver',
        SET_STATIC_APPROVERS: 'set-static-approvers',
        PROCESS_STATIC_APPROVERS: 'process-static-approvers',
        WIPE_APPROVER: 'wipe-approver',
        EDIT_HOTEL_DATES: 'edit-hotel-dates',
        EDIT_FLIGHT_DATES: 'edit-flights-dates',
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/config/events.constant.js